import React from "react";
import { AlertTriangle, FileSpreadsheet, Zap } from "lucide-react";

export default function PainSection() {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
        {/* LEFT: Pain visual */}
        <div className="relative">
          <div className="absolute -top-10 -left-10 w-72 h-72 bg-pink-100 rounded-full blur-3xl -z-10" />
          <div className="bg-gray-50 border border-gray-100 rounded-2xl shadow-xl p-8">
            <div className="flex items-center gap-3 mb-4">
              <FileSpreadsheet className="text-pink-600 w-6 h-6" />
              <h3 className="text-2xl font-semibold text-gray-900">
                Manual Prospecting Chaos
              </h3>
            </div>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>10+ Google tabs open</li>
              <li>Struggling with endless “site:”, “intext:” or “intitle:” queries</li>
              <li>Juggling multiple “guest post” and “SaaS” search strings</li>
              <li>Messy spreadsheets</li>
              <li>Copy-pasting DA/PA/Spam Score metrics manually</li>
            </ul>
          </div>
        </div>

        {/* RIGHT: Solution teaser */}
        <div className="text-center md:text-left">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
            You’re not doing link building - you’re doing{" "} 
            <span className="bg-gradient-to-r from-pink-600 to-red-500 bg-clip-text text-transparent">
              data entry
            </span>
            .
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Backlink Banana removes the grunt work: automated search, instant
            DA/PA/Spam Score metrics, and real LinkedIn contacts, ready for outreach. 
          </p>
          <a
            href="#showcase"
            className="inline-flex items-center gap-2 px-6 py-3 bg-pink-600 text-white font-semibold rounded-lg shadow hover:bg-pink-500 transition-all duration-300"
          >
            <Zap className="w-5 h-5" /> See How It Works
          </a>
        </div>
      </div>
    </section>
  );
}
